import { type Stripe, type StripeElementsOptions } from "@stripe/stripe-js";
import React from "react";
import StripePaymentMethod from "./StripePaymentMethod";

interface Props {
  stripe: Promise<Stripe>
  options: StripeElementsOptions
  returnUrl: string
  onHasLoaded: () => void
  isLoading: boolean
}

const Sepa = (props: Props) => {
  return <StripePaymentMethod
    clientSecret={props.options.clientSecret}
    returnUrl={props.returnUrl}
    onHasLoaded={props.onHasLoaded}
    isLoading={props.isLoading}
  />;
};

export default Sepa;